import {Observable} from 'rxjs';
import { Injectable, inject } from '@angular/core';
import {HttpEvent, HttpInterceptor, HttpRequest} from '@angular/common/http';

import {HttpHandler} from './http-handler';
import {AuthentificationService} from '../services/authentification.service';
import {LoaderService} from '../services/loader.service';
import {TranslateService} from '@ngx-translate/core';
import {takeUntil} from "rxjs/operators";
import {RequestCancellationService} from "../services/requestCancellationService";
import {JwtService} from '../services/jwt.service';


@Injectable()
export class NoopInterceptor implements HttpInterceptor {
    private authService = inject(AuthentificationService);
    private loaderService = inject(LoaderService);
    private translateService = inject(TranslateService);
    private requestCancellationService = inject(RequestCancellationService);
    private jwtService = inject(JwtService);

    private applicationJsonLd = 'application/ld+json';
    private multipartFormData = 'multipart/form-data';
    private textHtml = 'text/html';

    intercept(
        req: HttpRequest<any>,
        next: HttpHandler
    ): Observable<HttpEvent<any>> {
        //On ajouter un loader pour toute requête qui ne validate pas cette condition ( pour gérer des exculusions )
        if (
            !(req.url.indexOf('/api/fields/') !== -1) &&
            !(req.url.indexOf('noLoader') !== -1)
        ) {
            this.loaderService.addLoader();
        }
        return next.handle(this.prepareRequest(req)).pipe(
            takeUntil(this.requestCancellationService.cancelRequests) // Stoppe les requêtes si un signal est reçu
        );
    }

    setContentType(req: HttpRequest<any>) {
        let contentType = this.applicationJsonLd;
        if (req.url.indexOf('/api/fichiers') !== -1) {
            contentType = this.multipartFormData;
        }
        return contentType;
    }

    prepareRequest(req: HttpRequest<any>) {
        //Header par defaukt
        let header = {
            'Content-Type': this.setContentType(req),
            'Accept-language': this.acceptLanquage(),
        } as any;

        if (req.url.indexOf('fullHtml') !== -1) {
            header = {
                'Content-Type': this.textHtml,
                'Accept-language': this.acceptLanquage(),
            } as any;
        }

        if (req.url.indexOf('/api/fichiers') !== -1) {
            header = { 'Accept-language': this.acceptLanquage() } as any;
        }

        if (req.url.indexOf('/api/dossiers/exports/') !== -1) {
            header = { 'Accept-language': this.acceptLanquage(), Accept: 'text/csv' } as any;
        }

        //Si on a un token valide (non expiré) on l'ajoute. On évite ainsi d'envoyer un token
        //expiré, qui ferait échouer en 401 même les routes publiques.
        if (
            this.authService.token
            && req.url.indexOf('/api/login') === -1
            && !this.jwtService.isTokenExpired(this.authService.token)
        ) {
            header = {
                ...header,
                ...{ Authorization: 'Bearer ' + this.authService.token },
            };
        }

        // On configure l'entête de la requête avant de la renvoyer
        return req.clone({
            setHeaders: header,
        });
    }

    acceptLanquage() {
        return this.translateService.currentLang ?? this.authService.getLangueForUser();
    }
}
